import script from "./UsersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersTable.vue?vue&type=script&setup=true&lang=js"

import "./UsersTable.vue?vue&type=style&index=0&id=e96fd68e&lang=scss&scoped=true"
import "./UsersTable.vue?vue&type=style&index=1&id=e96fd68e&lang=scss"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e96fd68e"]])

export default __exports__